import { render } from "./fleet.cattle.io.gitrepo.vue?vue&type=template&id=615dd4c8&scoped=true"
import script from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js"

import "./fleet.cattle.io.gitrepo.vue?vue&type=style&index=0&id=615dd4c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615dd4c8"]])

export default __exports__